import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.dataset');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Service } from "src/libs/portal/season/service";

const DATASET_POSE_EDGES = [
    [11, 12], [11, 13], [12, 14], [11, 23], [12, 24], [23, 24],
];
const DATASET_POSE_VISIBLE_IDS = new Set([11, 12, 13, 14, 23, 24]);

@Component({ standalone: false,
    selector: 'wiz-page-xray-dataset',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.dataset/view.scss */
/* src/app/page.xray.dataset/view.scss: no such file or directory */`],
})
export class PageXrayDatasetComponent implements OnInit, OnDestroy {
    public dataset: any = this.emptyDataset();
    public loading = true;
    public buildBusy = false;
    public errorMessage = '';
    public notice = '';
    public uploadBusy = false;
    public uploadProgress = { current: 0, total: 0 };
    public lastImportItems: any[] = [];
    public lastImportFileCount = 0;
    public lastImportDuplicateCount = 0;
    public lastImportPredictionFailureCount = 0;
    public activeDataTab: 'source' | 'annotated' = 'source';
    public activeMediaType: 'image' | 'video' = 'image';
    public datasetItems: any[] = [];
    public datasetItemsTotal = 0;
    public datasetItemsOffset = 0;
    public readonly datasetItemsLimit = 24;
    public datasetDecision = '';
    public datasetQuery = '';
    public itemsLoading = false;
    public datasetThumbnailLoadLimit = 4;
    public datasetViewerItem: any = null;
    public datasetViewerDetail: any = null;
    public datasetViewerLoading = false;
    public datasetViewerTime = 0;
    public datasetViewerShowPose = true;
    public datasetViewerShowDetector = true;
    public datasetViewerThumbnailLoaded = false;
    public datasetViewerFullImageLoaded = false;
    public datasetViewerLivePosePoints: any[] = [];
    public datasetViewerLiveDetectorPolygon: any = null;
    public datasetViewerLiveSourceTime = -1;
    public datasetViewerLiveBusy = false;
    public datasetViewerLiveError = '';
    private datasetViewerLiveGeneration = 0;
    private datasetViewerLiveTrackingId = '';
    private datasetViewerLiveLastRequestedAt = 0;
    private pollTimer: any = null;
    private itemsLoadGeneration = 0;

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( Router)         public router: Router,@Inject( TranslateService    )         public translate: TranslateService    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        await Promise.all([this.load(), this.loadItems()]);
    }

    public ngOnDestroy() {
        this.stopPolling();
    }

    public go(path: string) {
        this.router.navigateByUrl(path);
    }

    public async importReviewFiles(event: Event) {
        const input = event.target as HTMLInputElement;
        const files = Array.from(input.files || []);
        if (!files.length || this.uploadBusy) return;
        this.uploadBusy = true;
        this.uploadProgress = { current: 0, total: files.length };
        this.errorMessage = '';
        this.notice = '';
        this.lastImportItems = [];
        this.lastImportFileCount = 0;
        this.lastImportDuplicateCount = 0;
        this.lastImportPredictionFailureCount = 0;
        await this.service.render();
        const errors: string[] = [];
        for (const file of files) {
            try {
                const form = new FormData();
                form.append('file', file, file.name);
                const response = await fetch(
                    '/wiz/api/page.xray.dataset_upload_runtime_v1/import_media',
                    {
                        method: 'POST',
                        body: form,
                        credentials: 'same-origin',
                    }
                );
                const { code, data } = await response.json();
                if (code !== 200) {
                    throw new Error(
                        data?.message || file.name + ' 파일을 추가하지 못했습니다.'
                    );
                }
                const result = data?.result || {};
                this.dataset = data?.dataset || this.dataset;
                this.lastImportItems.push(...(result?.review_items || []));
                this.lastImportFileCount += result?.imported ? 1 : 0;
                this.lastImportDuplicateCount += result?.duplicate ? 1 : 0;
                this.lastImportPredictionFailureCount += Number(
                    result?.prediction_failure_count || 0
                );
            } catch (error: any) {
                errors.push(
                    file.name + ': '
                    + this.callError(error, '등록하지 못했습니다.')
                );
            }
            this.uploadProgress.current += 1;
            await this.service.render();
        }
        input.value = '';
        this.uploadBusy = false;
        if (this.lastImportItems.length) {
            const firstMedia = this.lastImportItems[0]?.media_type === 'video'
                ? 'video'
                : 'image';
            this.activeMediaType = firstMedia;
            this.activeDataTab = 'source';
            this.datasetItemsOffset = 0;
            await this.loadItems();
            const imageCount = this.lastImportItems.filter(
                item => item?.media_type === 'image'
            ).length;
            const videoCount = this.lastImportItems.filter(
                item => item?.media_type === 'video'
            ).length;
            this.notice = [
                imageCount ? `사진 ${imageCount}장` : '',
                videoCount ? `동영상 대표 프레임 ${videoCount}장` : '',
            ].filter(Boolean).join(', ')
                + '을 원천 데이터와 AI 검수 대기에 등록했습니다.';
        }
        if (errors.length) {
            this.errorMessage = errors.join(' / ');
        } else if (!this.lastImportItems.length) {
            this.notice = '새 검수 항목은 없으며 중복 파일만 확인했습니다.';
        }
        await this.service.render();
    }

    public importedMediaCount(media: 'image' | 'video') {
        return this.lastImportItems.filter(
            item => item?.media_type === media
        ).length;
    }

    public firstImportedItem(media: 'image' | 'video') {
        return this.lastImportItems.find(
            item => item?.media_type === media
        ) || null;
    }

    public openDetectorReview(media?: 'image' | 'video') {
        const selectedMedia = media
            || (this.firstImportedItem('image') ? 'image' : 'video');
        const item = this.firstImportedItem(selectedMedia);
        const query = new URLSearchParams({
            mode: 'bucky-reaudit',
            media: selectedMedia,
        });
        if (item?.image_id) query.set('review_item', item.image_id);
        this.go('/page.xray/training/label-review?' + query.toString());
    }

    public openPoseReview(media: 'image' | 'video') {
        const item = this.firstImportedItem(media);
        const query = new URLSearchParams({ mode: 'pose', media });
        if (item?.image_id) query.set('review_item', item.image_id);
        this.go('/page.xray/training/normality-review?' + query.toString());
    }

    public async selectDataView(media: 'image' | 'video', tab: 'source' | 'annotated') {
        if (this.activeMediaType === media && this.activeDataTab === tab) return;
        this.activeMediaType = media;
        this.activeDataTab = tab;
        this.datasetItemsOffset = 0;
        await this.loadItems();
    }

    public dataViewActive(media: 'image' | 'video', tab: 'source' | 'annotated') {
        return this.activeMediaType === media && this.activeDataTab === tab;
    }

    public dataViewLabel() {
        return `${this.activeMediaType === 'video' ? '동영상' : '사진'} ${this.activeDataTab === 'source' ? '원천' : '라벨링'}`;
    }

    public async openDatasetViewer(item: any) {
        if (this.activeDataTab !== 'annotated' || !item?.image_id) return;
        this.datasetViewerItem = item;
        this.datasetViewerDetail = null;
        this.datasetViewerTime = item?.media_type === 'video'
            ? 0
            : Number(item?.video_time_seconds || 0);
        this.datasetViewerShowPose = true;
        this.datasetViewerShowDetector = true;
        this.datasetViewerThumbnailLoaded = false;
        this.datasetViewerFullImageLoaded = false;
        this.resetDatasetViewerLiveTracking();
        this.datasetViewerLoading = true;
        await this.service.render();
        if (item?.media_type === 'video') {
            await this.loadDatasetViewerDetail(item);
        }
    }

    private async loadDatasetViewerDetail(item: any) {
        const imageId = String(item?.image_id || '');
        if (!imageId || this.datasetViewerItem?.image_id !== item?.image_id) return;
        try {
            const response = await fetch(
                '/wiz/api/page.xray.dataset_viewer_runtime_v2/detail?image_id='
                + encodeURIComponent(imageId),
                { credentials: 'same-origin' }
            );
            const payload = await response.json();
            const code = Number(payload?.code || response.status || 500);
            const data = payload?.data || {};
            if (code !== 200) throw new Error(data?.message || '라벨 상세 정보를 불러오지 못했습니다.');
            if (this.datasetViewerItem?.image_id !== item?.image_id) return;
            this.datasetViewerDetail = data?.detail || null;
        } catch (error: any) {
            if (this.datasetViewerItem?.image_id !== item?.image_id) return;
            this.errorMessage = this.callError(error, '라벨 상세 정보를 불러오지 못했습니다.');
            this.datasetViewerItem = null;
        }
        if (this.datasetViewerItem?.image_id !== item?.image_id) return;
        this.datasetViewerLoading = false;
        await this.service.render();
    }

    public async onDatasetViewerThumbnailLoaded() {
        if (this.datasetViewerThumbnailLoaded) return;
        this.datasetViewerThumbnailLoaded = true;
        await this.service.render();
        if (this.datasetViewerItem?.media_type !== 'video') {
            await this.loadDatasetViewerDetail(this.datasetViewerItem);
        }
    }

    public async closeDatasetViewer(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.datasetViewerItem = null;
        this.datasetViewerDetail = null;
        this.datasetViewerLoading = false;
        this.datasetViewerTime = 0;
        this.datasetViewerThumbnailLoaded = false;
        this.datasetViewerFullImageLoaded = false;
        this.resetDatasetViewerLiveTracking();
        await this.service.render();
    }

    public datasetViewerSourceUrl() {
        if (!this.datasetViewerItem?.image_id) return '';
        return '/wiz/api/page.xray.dataset/reviewed_dataset_preview_v2?kind=source&image_id='
            + encodeURIComponent(this.datasetViewerItem.image_id);
    }

    public datasetViewerSourceThumbnailUrl() {
        if (!this.datasetViewerItem?.image_id) return '';
        return '/wiz/api/page.xray.dataset_viewer_runtime_v2/thumbnail?kind=source&image_id='
            + encodeURIComponent(this.datasetViewerItem.image_id)
            + '&v=' + encodeURIComponent(String(this.datasetViewerItem?.review_revision || 0));
    }

    public datasetViewerVideoUrl() {
        if (!this.datasetViewerItem?.image_id) return '';
        return '/wiz/api/page.xray.dataset_viewer_runtime_v2/video?image_id='
            + encodeURIComponent(this.datasetViewerItem.image_id);
    }

    public updateDatasetViewerTime(event: Event) {
        const video = event.target as HTMLVideoElement;
        this.datasetViewerTime = Number(video?.currentTime || 0);
        this.service.render();
        void this.captureDatasetViewerLiveFrame(video);
    }

    private resetDatasetViewerLiveTracking() {
        this.datasetViewerLiveGeneration += 1;
        this.datasetViewerLivePosePoints = [];
        this.datasetViewerLiveDetectorPolygon = null;
        this.datasetViewerLiveSourceTime = -1;
        this.datasetViewerLiveBusy = false;
        this.datasetViewerLiveError = '';
        this.datasetViewerLiveLastRequestedAt = 0;
        this.datasetViewerLiveTrackingId = (
            (window.crypto as any)?.randomUUID?.()
            || `dataset-viewer-${Date.now()}-${Math.random().toString(16).slice(2)}`
        );
    }

    private async captureDatasetViewerLiveFrame(video: HTMLVideoElement) {
        if (!video || video.readyState < 2 || !video.videoWidth || this.datasetViewerLiveBusy) return;
        const now = performance.now();
        if (!video.paused && now - this.datasetViewerLiveLastRequestedAt < 320) return;
        const generation = this.datasetViewerLiveGeneration;
        const sourceTime = Number(video.currentTime || 0);
        this.datasetViewerLiveLastRequestedAt = now;
        this.datasetViewerLiveBusy = true;
        try {
            const canvas = document.createElement('canvas');
            const scale = Math.min(1, 640 / video.videoWidth);
            canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
            canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
            const context = canvas.getContext('2d');
            if (!context) return;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(
                resolve, 'image/jpeg', .78
            ));
            if (!blob || generation !== this.datasetViewerLiveGeneration) return;
            const form = new FormData();
            form.append('image', blob, 'dataset-video-frame.jpg');
            form.append('realtime', '1');
            form.append('analysis_backend', 'yolo_candidate');
            form.append('tracking_id', this.datasetViewerLiveTrackingId);
            const response = await fetch('/wiz/api/page.xray/analyze_v2', {
                method: 'POST', body: form, credentials: 'same-origin',
            });
            const payload = await response.json();
            if (generation !== this.datasetViewerLiveGeneration) return;
            const data = payload?.data || {};
            const landmarks = Array.isArray(data?.landmarks) ? data.landmarks : [];
            if (landmarks.length) {
                this.datasetViewerLivePosePoints = landmarks.map((point: any, index: number) => ({
                    id: Number(point?.id ?? index),
                    x: Number(point?.x), y: Number(point?.y),
                    confidence: Number(point?.confidence ?? point?.visibility ?? 0),
                    visibility: Number(point?.confidence ?? point?.visibility ?? 0) >= .2
                        ? 'visible' : 'not_labeled',
                }));
            }
            const detector = data?.bucky_detection || data?.bucky || {};
            const corners = detector?.corners || detector?.detector_config?.corners || null;
            this.datasetViewerLiveDetectorPolygon = corners || null;
            this.datasetViewerLiveSourceTime = sourceTime;
            this.datasetViewerLiveError = landmarks.length
                ? '' : '현재 프레임에서 자세 모델 좌표를 찾지 못했습니다.';
        } catch (_error) {
            if (generation === this.datasetViewerLiveGeneration) {
                this.datasetViewerLiveError = '현재 프레임 모델 추적을 다시 시도하고 있습니다.';
            }
        } finally {
            if (generation === this.datasetViewerLiveGeneration) {
                this.datasetViewerLiveBusy = false;
                await this.service.render();
            }
        }
    }

    private datasetViewerLabelSegment(labels: any[]) {
        if (!labels?.length) return null;
        const sorted = [...labels].sort(
            (left: any, right: any) => Number(left?.time_seconds || 0) - Number(right?.time_seconds || 0)
        );
        const before = [...sorted].reverse().find(
            (item: any) => Number(item?.time_seconds || 0) <= this.datasetViewerTime
        ) || sorted[0];
        const after = sorted.find(
            (item: any) => Number(item?.time_seconds || 0) >= this.datasetViewerTime
        ) || sorted[sorted.length - 1];
        const beforeTime = Number(before?.time_seconds || 0);
        const afterTime = Number(after?.time_seconds || 0);
        const ratio = afterTime > beforeTime
            ? Math.max(0, Math.min(1, (this.datasetViewerTime - beforeTime) / (afterTime - beforeTime)))
            : 0;
        return { before, after, ratio };
    }

    private datasetViewerInterpolatedPoseField(field: string) {
        const segment = this.datasetViewerLabelSegment(
            this.datasetViewerDetail?.pose_labels || []
        );
        if (!segment) return [];
        const before = new Map<number, any>(
            (segment.before?.[field] || []).map((point: any) => [Number(point.id), point])
        );
        const after = new Map<number, any>(
            (segment.after?.[field] || []).map((point: any) => [Number(point.id), point])
        );
        return Array.from(new Set([...before.keys(), ...after.keys()])).map(id => {
            const first = before.get(id) || after.get(id);
            const second = after.get(id) || before.get(id);
            return {
                ...first,
                id,
                x: Number(first?.x || 0) + (Number(second?.x || 0) - Number(first?.x || 0)) * segment.ratio,
                y: Number(first?.y || 0) + (Number(second?.y || 0) - Number(first?.y || 0)) * segment.ratio,
                visibility: first?.visibility === 'not_labeled' && second?.visibility === 'not_labeled'
                    ? 'not_labeled'
                    : 'visible',
            };
        });
    }

    private datasetViewerInterpolatedDetectorPolygon(field = 'detector_polygon') {
        const segment = this.datasetViewerLabelSegment(
            this.datasetViewerDetail?.detector_labels || []
        );
        if (!segment) return {};
        const polygon: any = {};
        for (const key of ['top_left', 'top_right', 'bottom_right', 'bottom_left']) {
            const first = segment.before?.[field]?.[key]
                || segment.after?.[field]?.[key];
            const second = segment.after?.[field]?.[key]
                || segment.before?.[field]?.[key];
            if (!first || !second) continue;
            polygon[key] = {
                x: Number(first.x || 0) + (Number(second.x || 0) - Number(first.x || 0)) * segment.ratio,
                y: Number(first.y || 0) + (Number(second.y || 0) - Number(first.y || 0)) * segment.ratio,
            };
        }
        return polygon;
    }

    private datasetViewerTrackedPosePoints() {
        const saved = this.datasetViewerInterpolatedPoseField('pose_keypoints');
        if (
            !this.datasetViewerLivePosePoints.length
            || Math.abs(this.datasetViewerLiveSourceTime - this.datasetViewerTime) > .75
        ) return saved;
        const reference = new Map<number, any>(
            this.datasetViewerInterpolatedPoseField('pose_reference_keypoints')
                .map((point: any) => [Number(point.id), point])
        );
        const corrected = new Map<number, any>(
            saved.map((point: any) => [Number(point.id), point])
        );
        return this.datasetViewerLivePosePoints.map((point: any) => {
            const base = reference.get(Number(point.id));
            const target = corrected.get(Number(point.id));
            if (!base || !target) return point;
            return {
                ...point,
                x: Math.max(0, Math.min(1, Number(point.x) + Number(target.x) - Number(base.x))),
                y: Math.max(0, Math.min(1, Number(point.y) + Number(target.y) - Number(base.y))),
            };
        });
    }

    private datasetViewerTrackedDetectorPolygon() {
        const saved = this.datasetViewerInterpolatedDetectorPolygon();
        const livePoseFresh = this.datasetViewerLivePosePoints.length
            && Math.abs(this.datasetViewerLiveSourceTime - this.datasetViewerTime) <= .75;
        if (
            !this.datasetViewerLiveDetectorPolygon
            || Math.abs(this.datasetViewerLiveSourceTime - this.datasetViewerTime) > .75
        ) {
            if (!livePoseFresh || Object.keys(saved).length !== 4) return saved;
            const referencePoints = new Map<number, any>(
                this.datasetViewerInterpolatedPoseField('pose_reference_keypoints')
                    .map((point: any) => [Number(point.id), point])
            );
            const livePoints = new Map<number, any>(
                this.datasetViewerLivePosePoints.map((point: any) => [Number(point.id), point])
            );
            const ids = [11, 12].filter(id => referencePoints.has(id) && livePoints.has(id));
            if (!ids.length) return saved;
            const dx = ids.reduce((sum, id) => (
                sum + Number(livePoints.get(id).x) - Number(referencePoints.get(id).x)
            ), 0) / ids.length;
            const dy = ids.reduce((sum, id) => (
                sum + Number(livePoints.get(id).y) - Number(referencePoints.get(id).y)
            ), 0) / ids.length;
            return Object.fromEntries(Object.entries(saved).map(([key, point]: [string, any]) => [
                key,
                {
                    x: Math.max(0, Math.min(1, Number(point.x) + dx)),
                    y: Math.max(0, Math.min(1, Number(point.y) + dy)),
                },
            ]));
        }
        const reference = this.datasetViewerInterpolatedDetectorPolygon(
            'raw_detector_polygon'
        );
        const tracked: any = {};
        for (const key of ['top_left', 'top_right', 'bottom_right', 'bottom_left']) {
            const live = this.datasetViewerLiveDetectorPolygon?.[key];
            if (!live) continue;
            tracked[key] = reference?.[key] && saved?.[key]
                ? {
                    x: Math.max(0, Math.min(1, Number(live.x) + Number(saved[key].x) - Number(reference[key].x))),
                    y: Math.max(0, Math.min(1, Number(live.y) + Number(saved[key].y) - Number(reference[key].y))),
                }
                : live;
        }
        return Object.keys(tracked).length === 4 ? tracked : saved;
    }

    public datasetViewerPosePoints() {
        const points = this.datasetViewerTrackedPosePoints();
        return points.filter((point: any) => (
            DATASET_POSE_VISIBLE_IDS.has(Number(point?.id))
            &&
            point?.visibility !== 'not_labeled'
            && Number.isFinite(Number(point?.x))
            && Number.isFinite(Number(point?.y))
        ));
    }

    public datasetViewerPoseEdges() {
        const points = new Map<number, any>(
            this.datasetViewerPosePoints().map((point: any) => [Number(point.id), point])
        );
        return DATASET_POSE_EDGES.map(([from, to]) => ({
            from: points.get(from), to: points.get(to), key: `${from}-${to}`,
        })).filter(edge => edge.from && edge.to);
    }

    public datasetViewerDetectorPoints() {
        const polygon = this.datasetViewerTrackedDetectorPolygon();
        return ['top_left', 'top_right', 'bottom_right', 'bottom_left']
            .map(key => polygon?.[key])
            .filter(Boolean)
            .map(point => `${Number(point.x || 0) * 1000},${Number(point.y || 0) * 1000}`)
            .join(' ');
    }

    public datasetDecisionLabel(item: any) {
        if (item?.decision === 'NORMAL') return '정상';
        if (item?.decision === 'ABNORMAL') return '비정상';
        if (item?.decision === 'DETECTOR_GT') return 'Bucky GT';
        return item?.review_status === 'UNREVIEWED' ? '검수 대기' : 'Pose 검수';
    }

    public datasetDecisionClass(item: any) {
        if (item?.decision === 'NORMAL') return 'bg-emerald-100 text-emerald-800';
        if (item?.decision === 'ABNORMAL') return 'bg-red-100 text-red-800';
        if (item?.review_status === 'UNREVIEWED') return 'bg-amber-100 text-amber-800';
        return 'bg-cyan-100 text-cyan-800';
    }

    public async loadItems() {
        const loadGeneration = ++this.itemsLoadGeneration;
        const requestedMedia = this.activeMediaType;
        const requestedTab = this.activeDataTab;
        this.itemsLoading = true;
        this.datasetThumbnailLoadLimit = 4;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('list_reviewed_dataset_items_v2', {
                kind: requestedTab,
                media_type: requestedMedia,
                offset: this.datasetItemsOffset,
                limit: this.datasetItemsLimit,
                decision: this.datasetDecision,
                query: this.datasetQuery.trim(),
            });
            if (loadGeneration !== this.itemsLoadGeneration) return;
            if (code !== 200) throw new Error(data?.message || '데이터 목록을 불러오지 못했습니다.');
            const result = data?.dataset_items || {};
            const responseItems = result?.items || [];
            this.datasetItems = responseItems.filter(
                (item: any) => item?.media_type === requestedMedia
            );
            this.datasetItemsTotal = (
                this.datasetItems.length === responseItems.length
                ? Number(result?.total || 0)
                : this.datasetItems.length
            );
        } catch (error: any) {
            if (loadGeneration !== this.itemsLoadGeneration) return;
            this.datasetItems = [];
            this.datasetItemsTotal = 0;
            this.errorMessage = this.callError(error, '데이터 목록을 불러오지 못했습니다.');
        }
        if (loadGeneration !== this.itemsLoadGeneration) return;
        this.itemsLoading = false;
        await this.service.render();
    }

    public async onDatasetThumbnailSettled(itemIndex: number) {
        if (itemIndex >= this.datasetThumbnailLoadLimit) return;
        if (this.datasetThumbnailLoadLimit >= this.datasetItems.length) return;
        this.datasetThumbnailLoadLimit += 1;
        await this.service.render();
    }

    public async applyDatasetFilters() {
        this.datasetItemsOffset = 0;
        await this.loadItems();
    }

    public async moveDatasetPage(direction: number) {
        const next = Math.max(
            0,
            Math.min(
                this.lastDatasetOffset(),
                this.datasetItemsOffset + direction * this.datasetItemsLimit
            )
        );
        if (next === this.datasetItemsOffset) return;
        this.datasetItemsOffset = next;
        await this.loadItems();
    }

    public datasetPreviewUrl(item: any) {
        return '/wiz/api/page.xray.dataset_viewer_runtime_v2/thumbnail?image_id='
            + encodeURIComponent(String(item?.image_id || ''))
            + '&kind=' + encodeURIComponent(this.activeDataTab)
            + '&v=' + encodeURIComponent(String(item?.review_revision || 0));
    }

    public datasetPageNumber() {
        return Math.floor(this.datasetItemsOffset / this.datasetItemsLimit) + 1;
    }

    public datasetPageCount() {
        return Math.max(1, Math.ceil(this.datasetItemsTotal / this.datasetItemsLimit));
    }

    private lastDatasetOffset() {
        return Math.max(
            0,
            (this.datasetPageCount() - 1) * this.datasetItemsLimit
        );
    }

    public async load(quiet = false) {
        if (!quiet) this.loading = true;
        if (!quiet) this.errorMessage = '';
        try {
            const { code, data } = await wiz.call('load_reviewed_dataset_v1', {});
            if (code === 200) {
                this.dataset = data?.dataset || this.emptyDataset();
                if (this.building()) this.startPolling();
                else this.stopPolling();
            } else if (!quiet) {
                this.errorMessage = data?.message || '검수 데이터셋 현황을 불러오지 못했습니다.';
            }
        } catch (error: any) {
            if (!quiet) this.errorMessage = this.callError(error, '검수 데이터셋 현황을 불러오지 못했습니다.');
        }
        this.loading = false;
        await this.service.render();
    }

    public async buildZip() {
        if (this.buildBusy || this.building()) return;
        this.buildBusy = true;
        this.notice = '';
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('start_reviewed_dataset_build_v1', {});
            if (code === 200 || code === 202) {
                this.dataset = data?.dataset || this.dataset;
                this.notice = data?.dataset?.message || '데이터셋 ZIP 생성을 시작했습니다.';
                if (this.building()) this.startPolling();
            } else {
                this.errorMessage = data?.message || '데이터셋 ZIP 생성을 시작하지 못했습니다.';
            }
        } catch (error: any) {
            this.errorMessage = this.callError(error, '데이터셋 ZIP 생성을 시작하지 못했습니다.');
        }
        this.buildBusy = false;
        await this.service.render();
    }

    public downloadZip() {
        if (!this.dataset?.artifact?.available) return;
        window.location.href = '/wiz/api/page.xray.dataset/download_reviewed_dataset_v1';
    }

    public building() {
        return ['queued', 'running'].includes(this.dataset?.job?.status);
    }

    public buildLabel() {
        if (this.building()) return `ZIP 생성 중 ${Number(this.dataset?.job?.progress_percent || 0).toFixed(1)}%`;
        if (this.dataset?.artifact?.fresh) return '현재 검수본으로 ZIP 다시 만들기';
        if (this.dataset?.artifact?.available) return '변경된 검수본으로 ZIP 갱신';
        return '521장 데이터셋 ZIP 만들기';
    }

    public jobStatusLabel() {
        const status = this.dataset?.job?.status;
        if (status === 'queued') return '생성 대기';
        if (status === 'running') return '생성 중';
        if (status === 'completed') return '생성 완료';
        if (status === 'failed') return '생성 실패';
        return '생성 전';
    }

    public formatBytes(value: any) {
        const bytes = Number(value || 0);
        if (!bytes) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        const index = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
        return `${(bytes / Math.pow(1024, index)).toFixed(index ? 1 : 0)} ${units[index]}`;
    }

    private startPolling() {
        if (this.pollTimer) return;
        this.pollTimer = setInterval(() => this.pollStatus(), 1500);
    }

    private stopPolling() {
        if (!this.pollTimer) return;
        clearInterval(this.pollTimer);
        this.pollTimer = null;
    }

    private async pollStatus() {
        try {
            const { code, data } = await wiz.call('reviewed_dataset_status_v1', {});
            if (code === 200) {
                const previousStatus = this.dataset?.job?.status;
                this.dataset = data?.dataset || this.dataset;
                if (!this.building()) {
                    this.stopPolling();
                    if (previousStatus === 'queued' || previousStatus === 'running') {
                        this.notice = this.dataset?.job?.message || '데이터셋 ZIP 생성이 끝났습니다.';
                    }
                }
            }
        } catch (error: any) {
            this.stopPolling();
            this.errorMessage = this.callError(error, '데이터셋 ZIP 생성 상태를 확인하지 못했습니다.');
        }
        await this.service.render();
    }

    private callError(error: any, fallback: string) {
        return String(error?.data?.message || error?.message || fallback);
    }

    private emptyDataset() {
        return {
            reviewed: 0,
            normal: 0,
            abnormal: 0,
            abnormal_category_copies: 0,
            media_counts: { image_labeled: 0, video_labeled: 0 },
            reason_counts: {},
            reason_folders: [],
            artifact: { available: false, fresh: false, filename: '', size_bytes: 0 },
            job: { status: 'idle', progress_percent: 0, processed: 0, total: 0 },
        };
    }
}

export default PageXrayDatasetComponent;